/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* import specific icons */
import {
    faUserSecret,
    faTasks,
    faCoins,
    faSpinner,
    faTrash,
    faPencilAlt,
    faAngleUp,
    faAngleDoubleLeft,
    faAngleLeft,
    faAngleRight,
    faAngleDoubleRight,
    faEllipsis,
    faFilter,
    faCalendarDays,
    faPaperPlane,
    faChevronRight,
    faTrashCan,
    faSearch,
    faBell,
    faCheck,
    faXmark,
    faUser,
    faCog,
    faSignOutAlt,
    faArrowUpRightFromSquare,
    faFolder,
    faFolderOpen,
    faUsers,
    faHeadphones,
    faCircle,
    faCopy
} from "@fortawesome/free-solid-svg-icons";

import {
    faClock,
    faBookmark,
    faFileAlt,
} from "@fortawesome/free-regular-svg-icons";

export default {
    install: (app, options) => {
        /* add icons to the library */
        library.add(
            faUserSecret,
            faTasks,
            faCoins,
            faSpinner,
            faTrash,
            faPencilAlt,
            faAngleUp,
            faAngleDoubleLeft,
            faAngleLeft,
            faAngleRight,
            faAngleDoubleRight,
            faEllipsis,
            faFilter,
            faCalendarDays,
            faPaperPlane,
            faChevronRight,
            faTrashCan,
            faClock,
            faBookmark,
            faSearch,
            faBell,
            faCheck,
            faXmark,
            faUser,
            faCog,
            faSignOutAlt,
            faFileAlt,
            faArrowUpRightFromSquare,
            faFolder,
            faFolderOpen,
            faUsers,
            faHeadphones,
            faCircle,
            faCopy
        );

        app.component("font-awesome-icon", FontAwesomeIcon);
    },
};
